import { Grouping } from '@devexpress/dx-react-grid';
import { UpdateOrdersActionPayload } from './rootReducerTypes';
import { OrderStatusCount } from '../Interfaces';

// #region actions
export type OrderListActionTypes =
    UpdateOrdersAction
    | RequestErrorAction
    | FetchInitAction
    | SetCurrentPageAction
    | UpdateQueryAction
    | SetPageSizeAction
    | UpdateShowHistoricalAction
    | UpdateSortByAction
    | UpdateTotalCountByOrderStatus
    | UpdateSearchOrdersAction
    | ChangeGroupingAction
    | SetExpandedGroupsAction

export const UPDATE_ORDERS = "UPDATE_ORDERS";
export interface UpdateOrdersAction {
    type: typeof UPDATE_ORDERS;
    updateOrdersActionPayload: UpdateOrdersActionPayload;
}

export const REQUEST_ERROR = "REQUEST_ERROR";
export interface RequestErrorAction {
    type: typeof REQUEST_ERROR;
}

export const FETCH_INIT = "FETCH_INIT";
export interface FetchInitAction {
    type: typeof FETCH_INIT;
}

export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export interface SetCurrentPageAction {
    type: typeof SET_CURRENT_PAGE;
    currentPage: number;
}
export const SET_PAGE_SIZE = "SET_PAGE_SIZE";
export interface SetPageSizeAction {
    type: typeof SET_PAGE_SIZE;
    pageSize: number;
}
export const UPDATE_QUERY = "UPDATE_QUERY";
export interface UpdateQueryAction {
    type: typeof UPDATE_QUERY;
    lastQuery: string;
}

export const UPDATE_SHOW_HISTORICAL = "UPDATE_SHOW_HISTORICAL";
export interface UpdateShowHistoricalAction {
    type: typeof UPDATE_SHOW_HISTORICAL;
    showHistorical: boolean;
}

export const UPDATE_SORTBY = "UPDATE_SORTBY";
export interface UpdateSortByAction {
    type: typeof UPDATE_SORTBY;
    sortBy: string;
}

export const UPDATE_TOTAL_COUNT_BY_ORDER_STATUS = "UPDATE_TOTAL_COUNT_BY_ORDER_STATUS";
export interface UpdateTotalCountByOrderStatus {
    type: typeof UPDATE_TOTAL_COUNT_BY_ORDER_STATUS;
    totalCountByOrderStatus: OrderStatusCount;
}

export const UPDATE_SEARCH_ORDERS = "UPDATE_SEARCH_ORDERS";
export interface UpdateSearchOrdersAction {
    type: typeof UPDATE_SEARCH_ORDERS;
    searchText: string;
}

export const CHANGE_GROUPING = "CHANGE_GROUPING";
export interface ChangeGroupingAction {
    type: typeof CHANGE_GROUPING,
    grouping: Grouping[]
}

export const SET_EXPANDED_GROUPS = "SET_EXPANDED_GROUPS"
export interface SetExpandedGroupsAction {
    type: typeof SET_EXPANDED_GROUPS,
    expandedGroups: string[]
}
